const APIS = {
  INVOICE: '/invoiceservice/api/merchant-invoice/',
  BUSINESS_PROFILE: '/logisticservice/api/business-profile/',
  ORDER: '/logisticservice/api/order/',
  USER_PROFILE: 'logisticservice/api/user-profile/',
  CLIENT_SETTING: 'projectsettingsservice/api/configuration/',
  PAYMENT_METHOD: '/invoice/payment-method/',
  MAKE_PAYMENT: '/invoice/make-payment/',
};

export default APIS;
